import popMgr from '@/components/global/popMgr';
import util from '@/common/util';
import { useUserStore, usePageStore } from '@/store';

const styleMap = {
    standard: () =>
        import(
            /* webpackChunkName: "common/vowPassword/standard"*/ './standard.vue'
        )
};

const BASE_GAP_STAMP = 30 * 24 * 60 * 60 * 1000;
const psMap = {};

const vowPassword = {
    prepare(style) {
        if (!psMap[style]) {
            let mappedStyle = styleMap[style] || styleMap.standard;
            psMap[style] = mappedStyle();
        }
        return psMap[style];
    },
    open({ options = {} }) {
        const style = 'standard';
        const cur = popMgr.getCurrent();
        if (cur?.name === 'vowPassword') {
            return;
        }
        const vdata = {
            name: 'vowPassword',
            options,
        };
        this.prepare(style).then(pop => {
            popMgr.create(pop.default, vdata, 'hideOtherPop');
        });
    },
    check({ globalData }) {
        const userStore = useUserStore();
        const pageStore = usePageStore();
        console.log('vow check userStore ===>>>>', userStore.user)
        const moduleData = pageStore.moduleData || [];
        const hasVowInMLS = (globalData.mlsOrgs || []).find(item => !!item.soldProtected && (item.status || '').toLocaleLowerCase() === 'active');
        const pageKey = globalData.pageKey
        const curSiteId = globalData.siteId
        const hasListingModule = moduleData.some(item => ['md-house', 'md-search', 'md-house-listing', 'md-property-promotion', 'md-search-result', 'md-listing-list', 'md-search-grid-list', 'md-search-big-map'].includes(item.name));
        if (userStore.user && hasVowInMLS && (hasListingModule || ['listing-detail',  'listing-detail-sold', 'promotion'].includes(pageKey))) {
            const { verifyTime, vowListingsStatus } = userStore.user
            if (vowListingsStatus) {
                const lastUpdateTimeForPassword = verifyTime || new Date().valueOf();
                const curTime = new Date().valueOf();
                const gapStamp = curTime - lastUpdateTimeForPassword;

                const vow_password_key = 'vow_password_key' + '_' + curSiteId
                const lastTimeStorage = localStorage.getItem(vow_password_key);

                const oneDayGap = 24 * 60 * 60 * 1000
                let hasOneDayGap = false
                if (lastTimeStorage) {
                    hasOneDayGap = curTime - lastTimeStorage > oneDayGap
                }

                if (gapStamp > BASE_GAP_STAMP && (!lastTimeStorage || hasOneDayGap)) {
                    this.open({ options: {} });
                }
            }
        }
    },
    init(globalData) {
        if (util.isSSRServer) {
            return;
        }
        window.siteAppVm.$EventBus.$on('userLogin', user => {
            if (!user) {
                return;
            }
            this.check({ globalData });
        });
    }
};

export default vowPassword;
